import PageWithSubRoute from "./PageWithSubRoute.presenter";

export default PageWithSubRoute;

export { default as SubRouteMenu } from "./SubRouteMenu";
